import { createFileRoute } from '@tanstack/react-router'

import SubmissionDetailPage from '@/components/pages/backoffice/edit-penyuluh/submission/_$verificationId/container/DetailSubmissionPage'

export const Route = createFileRoute(
  '/_backoffice/edit-penyuluh/submission/$verificationId/'
)({
  component: SubmissionDetailPage
})
